import HttpMethodType from 'HttpMethodType';
import SubSystemType from 'SubSystemType';
import BaseServiceRequest from 'BaseServiceRequest';

class DeleteCustomMetric extends BaseServiceRequest {
    constructor(metricId) {
        super();
        super.addRequestUri("deletecustomcol.pb");
        super.addRequestParameter("dataitemid", metricId.toString());
    }

    getMethod() {
        return HttpMethodType.PUT;
    }

    getSubSystem() {
        return SubSystemType.LIST;
    }

    getMessageName() {
        return "Response";
    }
}

export default DeleteCustomMetric;